<template>
  <div v-if="hasBanner" class="carousel">
    <carousel
      class="carousel_stage"
      ref="carousel"
      :perPage="1"
      :centerMode="true"
      :mouseDrag="true"
      :paginationEnabled="false"
      :spacePadding="10"
      :scrollPerPage="false">
      <slide v-for="(item, index) in banners" :key="index" class="carousel_stage_item">
        <center-slider-item :banner="item" @click="selectPromotionHandler"></center-slider-item>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import centerSliderItem from '@/components/mobile/slider/center-slider-item.vue';
import { createPromotionItem, sendGA4sEvent } from '@/helpers/tracking/ga';

const computed = {
  hasBanner() {
    return this.banners.length > 0;
  },
  banners() {
    return this.$store.state.Cart.banners || [];
  },
};

const methods = {
  selectPromotionHandler(banner) {
    const parameterForGA = createPromotionItem(banner);
    sendGA4sEvent('select_promotion', parameterForGA);
  },
};

const components = {
  Carousel,
  Slide,
  centerSliderItem,
};

export default {
  computed,
  components,
  methods,
};
</script>
